module.exports = __webpack_public_path__ + "img/popop_red_8.cb17d3ae.png";